import { useRef, useEffect } from 'react'
import axios, { CancelToken, CancelTokenSource } from 'axios'

const useCancelToken = (): {
  newCancelToken: () => CancelToken
  isCancel: (value: unknown) => boolean
} => {
  const axiosSource = useRef<CancelTokenSource | null>(null)
  const newCancelToken = (): CancelToken => {
    axiosSource.current = axios.CancelToken.source()
    return axiosSource.current.token
  }

  useEffect(
    () => () => {
      if (axiosSource.current) {
        axiosSource.current.cancel()
      }
    },
    [],
  )

  return { newCancelToken, isCancel: axios.isCancel }
}

export default useCancelToken
